module.exports = __webpack_public_path__ + "img/Pattern02.9681bde4.png";